import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 配置React Router future flags
// 下面是将来升级到React Router v7时的配置示例
/* 将来启用时需要导入:
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const router = createBrowserRouter(
  [{ path: "*", Component: App }],
  {
    future: {
      v7_startTransition: true, 
      v7_relativeSplatPath: true
    }
  }
);
*/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);

/**
 * 发送性能指标到分析服务
 * 可以发送到Google Analytics、百度统计或自定义的分析服务
 */
reportWebVitals(metric => {
  // 记录性能指标到控制台
  console.log(metric);
  
  // 如果存在Google Analytics，发送到Google Analytics
  if (window.gtag) {
    window.gtag('event', 'web_vitals', {
      event_category: 'Web Vitals',
      event_action: metric.name,
      event_value: Math.round(metric.value),
      event_label: metric.id,
      non_interaction: true, // 避免影响跳出率
    });
  }
  
  // 如果需要，也可以发送到其他分析工具
  // 例如百度统计
  if (window._hmt) {
    window._hmt.push(['_trackEvent', 'Web Vitals', metric.name, metric.id, Math.round(metric.value)]);
  }
}); 